export default "__VITE_ASSET__tZ4$xDrs__"